function createUser(element) {
  return {
    id: element.account.id,
    name: element.profile.name,
    last_name: element.profile.last_name,
    profile_type: element.profile.profile_type,
    email: element.account.email,
    password: element.account.token,
    card_id: element.profile.card_id,
    birthday_date: element.profile.birthday_date,
    region: element.profile.region,
    username: element.account.username,
    status: element.account.status,
    full_name: `${element.profile.name} ${element.profile.last_name}`,
    card_type_id: element.profile.card_type_id,
    address: element.profile.address,
    city: element.profile.city,
    phone_number: element.profile.phone_number,
    zip_code: element.profile.zip_code,
  };
}

function createOwner(element) {
  return {
    ...createUser(element),
    company_name: element.profile.company_name,
    company_code: element.profile.company_code,
    account_type: element.bank_account.account_type,
    account_name: element.bank_account.account_name,
    bank_name: element.bank_account.bank_name,
    bank_account: element.bank_account.bank_account,
    schools: element.schools,
    stores: element.stores,
  };
}

function createParent(element) {
  return {
    ...element,
    full_name: `${element.name} ${element.last_name}`,
    status: element.status_id,
    profile_type: element.profile_type_id,
    pupils: element.pupils && element.pupils.length > 0 ? element.pupils.map(pupil => ({
      ...pupil,
      full_name: `${pupil.name} ${pupil.last_name}`
    })) : [],
  };
}

export default {
  SET_USERS(state, users) {
    state.users = users.map(createUser);
  },
  REMOVE_RECORD(state, itemId) {
    state.users = state.users.filter((u) => u.id !== itemId);
    state.owners = state.owners.filter((u) => u.id !== itemId);
  },
  ADD_USER(state, user_data) {
    state.users.unshift(createUser(user_data));
  },
  UPDATE_USER(state, user_data) {
    const updatedUser = createUser(user_data);
    const userIndex = state.users.findIndex((u) => u.id === updatedUser.id);
    if (userIndex !== -1) {
      Object.assign(state.users[userIndex], updatedUser);
    }
  },
  SET_OWNERS(state, owners) {
    state.owners = owners.map(createOwner);
  },
  SET_PARENTS(state, parents) {
    state.parents = parents.map(createParent);
  },
  UPDATE_PARENT(state, parent) {
    const updatedParent = createParent(parent);
    const parentIndex = state.parents.findIndex((u) => u.document === updatedParent.document);
    if (parentIndex !== -1) {
      Object.assign(state.parents[parentIndex], updatedParent);
    }
  },
  UPDATE_OWNER(state, owner) {
    const updatedOwner = createOwner(owner);
    const ownerIndex = state.owners.findIndex((u) => u.id === updatedOwner.id);
    if (ownerIndex !== -1) {
      Object.assign(state.owners[ownerIndex], updatedOwner);
    }
  },
  ADD_OWNER(state, item) {
    state.owners.unshift(createOwner(item));
  },
  ADD_PARENT(state, item) {
    state.parents.unshift(createParent(item.profile));
  }
};
